import { render, staticRenderFns } from "./CreateOpportunity.vue?vue&type=template&id=86ba959c&"
import script from "./CreateOpportunity.vue?vue&type=script&lang=js&"
export * from "./CreateOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports